<div class="domain-filter-container" [ngClass]="'variant-' + variant">
  <ng-container *ngFor="let filter of domainFilters">
    <div class="domain-filter {{filter.shortName?.toLowerCase()}}" [class.active]="isActive(filter.id)"
         (click)="toggleFilter(filter.id)">
      {{getDomainFilterLabel(filter.shortName).toUpperCase()}}
    </div>
  </ng-container>
</div>
